// ONE POS yordami: Telegram bot. Restoran egasi yoki xodimi bir bosishda yozadi.
// "start" parametrida restoran ID'si — bot qaysi restorandan yozilganini biladi (parol yoki shaxsiy ma'lumot yo'q).
export const SUPPORT_TELEGRAM = 'Onepos_yordambot';

export function supportUrl(tenantId?: string | null): string {
  const base = `https://t.me/${SUPPORT_TELEGRAM}`;
  if (!tenantId) return base;
  // Telegram start parametri: faqat A-Z a-z 0-9 _ - (64 belgigacha)
  return `${base}?start=r_${tenantId.replace(/[^A-Za-z0-9]/g, '')}`;
}
